const GET_TRANSFER_GRID_DATA = 'GET_TRANSFER_GRID_DATA';
const SET_TRANSFER_GRID_DATA = 'SET_TRANSFER_GRID_DATA';
const GET_TRANSFER_GRID_COUNT = 'GET_TRANSFER_GRID_COUNT';
const SET_TRANSFER_GRID_COUNT = 'SET_TRANSFER_GRID_COUNT';
const IS_MY_ORDERS_GRID_LOADING = 'IS_MY_ORDERS_GRID_LOADING';
const IS_MY_ORDERS_GRID_COUNTS_LOADING = 'IS_MY_ORDERS_GRID_COUNTS_LOADING'


export {
    GET_TRANSFER_GRID_DATA,
    SET_TRANSFER_GRID_DATA,
    GET_TRANSFER_GRID_COUNT,
    SET_TRANSFER_GRID_COUNT,
    IS_MY_ORDERS_GRID_LOADING,
    IS_MY_ORDERS_GRID_COUNTS_LOADING
};
